// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ok-0";
export var animationContainer = "_ok-1";
export var itemPrice = "_ok-a";
export var itemizedContent = "_ok-9";
export var itemizedHeader = "_ok-7";
export var itemizedRow = "_ok-8";
export var itemizedSection = "_ok-6";
export var modalContent = "_ok-2";
export var orderName = "_ok-3";
export var refundOption = "_ok-4";
export var refundOptionsContainer = "_ok-5";
export var shippingLabel = "_ok-b";
export var totalRow = "_ok-c";